import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import {IconClose} from './Icons';
import Settings from './Settings';

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class StartSite extends Component {

  @observable categories = [];
  @observable products = [];

  @observable showComponentVar = false;
  @observable showProductsVar = false;

  @observable onlyProducts = false;

  constructor(props) {

    super(props);

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

    let scope = this;



    session.getSessionFromShop().then((sts)=> {

      $.ajax({
        // cache: false,
        headers: {
          'x-client-id': bf_config.clientID
        },
        url: bf_config.api + 'categories',
        dataType: "json",
        method: "get",
        success:  (data)=> {

          if ( data.length > 1 )
          {
            scope.loadCategories(data);
            if ( categoryID != '' )
            {
              scope.getProductsFromCat(categoryID);
            }
          }
          else
          {
            $('.js-category').hide();
            this.onlyProducts = true;
            scope.getProductsFromCat(data[0].id);
          }
        },
        error: function (data) {
        }
      });
    });

    this.bindEvents();

  }

  bindEvents() {
    let scope = this;
    $(document).on('click','#js-cat-list li',function(){
      var id = $(this).attr('data-id');
      scope.getProductsFromCat(id);
    })
  }



  choiceCateogry(id){
    this.getProductsFromCat(id);
  }

  getProductsFromCat(id)
  {

    $.ajax({
      cache: true,
      headers: {
        'x-client-id': bf_config.clientID
      },
      url:  bf_config.api + 'categories/' + id + '/products',
      dataType: "json",
      method : "get",
      success: (data) =>
      {
        this.loadProducts(data);
      },
      error: (data) =>
      {

      }
    });
  }


   loadCategories(data)
  {

   // var source = $("#cat-list").html();
   // var template = Handlebars.compile(source);

    for ( var i in data )
    {
      data[i].image = new Object();
      var images = data[i].images;
      for ( var j in images){
        if ( images[j].type == 'default' )
        {
          data[i].image.thumbUrl = images[j].thumbUrl;
        }
        else {
          data[i].image.thumbUrlHover = images[j].thumbUrl;
        }
      }
    }
    //console.log('_data',data);
    this.categories = data;

    //$('#js-cat-list').html(template(data));
    setTimeout(function() {
      $('.js-category').removeClass('opacity-hide');
    },1000);

  }


   loadProducts(data)
  {

    var source = $("#prod-list").html();
    var template = Handlebars.compile(source);
    var data = this.getCatThumb(data);

    this.products = data;

  //  $('#js-prod-list').html(template(data));


      this.showProducts();




  }


   getCatThumb(data)
  {

    for ( var i in data )
    {

      var current = data[i];
      current.nocomplete = false;

      current.shref = bf_config.home_url + 'creator.php?prodID=' +current.id +'&clientID='+bf_config.clientID+'&lang='+bf_config.currentLang;


      data[i].image = new Object();
      var images = data[i].images;
      for ( var j in images){

        if ( images[j].type == 'default' )
        {
          try{
            data[i].image.thumbUrl = images[j].thumbUrl;

          }
          catch(e){
            current.thumbUrl = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
            current.nocomplete = true;
          }
        }
        else {
          data[i].image.thumbUrlHover = images[j].thumbUrl;
        }
      }




      if ( current.views == undefined || current.views == null || current.views.length < 1 )
      {
        current.nocomplete = true;
      }
      else
      {
        var isOneActive = false;
        for ( var i in current.views )
        {

          if ( current.views[i].active == true )
          {
            isOneActive = true;
            if ( current.views[i].images.length < 4 )
            {
              isOneActive = false;
            }
          }
        }
        if ( isOneActive == false )
        {
          current.nocomplete = true;
        }
      }


      if ( session.getIsDealer() )
      {

        for ( var j in current.groupPrices ) {

          if (current.groupPrices[j].groupId == session.getDealerGroupId()) {
            current.price = current.groupPrices[j].price;
          }
        }
      }
      else {

        for ( var j in current.groupPrices ) {
          if (current.groupPrices[j].groupId == 'EK') {
            current.price = current.groupPrices[j].price;
          }
        }
      }

      if ( current.image == null || current.price == null )
      {
        current.nocomplete = true;
      }

    }

    return data;
  }

  closeStartSize(){
    $('.js-category').addClass('opacity-hide');

    setTimeout(()=> {
      Settings.setShowCategoryPopup(false);
    },400);
  }

  showProducts(){
    this.showProductsVar = true;


    setTimeout(()=> {
      $('.js-variant').removeClass('opacity-hide');

    },200);
  }

  closeProducts() {
    $('.js-category').removeClass('opacity-hide');
    $('.js-variant').addClass('opacity-hide');
    setTimeout(() => {
      this.showProductsVar = false;
    }, 400);

    if (this.onlyProducts) {
      this.closeStartSize();

    }
  }

  render() {

    const trans = this.trans;
    const t = this.t;

    const langCode =  this.props.dictionaryStorage.currentLang;

    if (this.onlyProducts )
    {
      setTimeout(()=> {
        $('.js-variant').removeClass('opacity-hide');
        if ( $('.StartSiteIndex').length > 0 )
        {
          $('.bf-start-variant').removeClass('popup');
          $('.StartSite-close').css('display','none');
         // $('.StartSiteIndex').height('600px');
        }

       ;
      },200);
    }

    return (
      <div className="StartSite">
        {
        ( ( Settings.getSettingsShowCategoryPopup || !this.props.popup ) )
         &&
        <span className="StartSite-container">
          {
            !this.onlyProducts
            &&
            <div
              className={"bf-start-category bf-start-block js-category " + (  this.props.popup ? 'popup' : 'opacity-hide' )}>
              <div className="container-full">

                <div className="container">
                  <h2 className="title"><span>{t('Select category')}</span></h2>
                  <ul className="start-list">
                    {
                      _.map(this.categories, (cat, key) => {

                        return (
                          <li
                            key={key}
                            onClick={ () => {
                              this.choiceCateogry(cat.id)
                            } }

                          >
                            <h3 className="cat-prod-title">{this.tp(toJS(cat), langCode, 'name')}</h3>
                            <div className="img">
                        <span>
                             <img src={cat.image.thumbUrl}/>
                             <img src={cat.image.thumbUrlHover}/>
                        </span>
                            </div>
                          </li>
                        )
                      })
                    }
                  </ul>
                  {
                    this.props.popup
                    &&
                    <span className="StartSite-close">
                <span onClick={() => {
                  this.closeStartSize()
                } }>
                  <span>{t('Close')}</span>
                  <IconClose size="big"/>
                </span>
              </span>
                  }

                </div>
              </div>
            </div>
          }
        {
          ( this.showProductsVar || ( this.onlyProducts ) )
          &&
          <div className={"bf-start-variant bf-start-block js-variant popup opacity-hide"  }>
            <div className="container-full">
              <div className="container ">
                <h2 className="title"><span>{t('Select product')}</span></h2>
                <ul className="start-list">
                  {
                    _.map(this.products, (elem, key) => {
                      return (
                        <li key={key} >
                          <h3 className="cat-prod-title">{this.tp(toJS(elem),langCode,'name')}</h3>
                          <a className="img" href={elem.shref}>
                          <span>
                               <img src={elem.image.thumbUrl}/>
                               <img src={elem.image.thumbUrlHover}/>
                          </span>
                          </a>
                        </li>
                      )
                    })
                  }
                </ul>
                <span className="StartSite-close">
                <span  onClick={()=>{this.closeProducts()}}>
                  <span>{t('Close')}</span>
                  <IconClose size="big" />
                </span>
              </span>
              </div>
            </div>
          </div>
        }
        </span>
        }
      </div>
    );


  }
}






